export interface Privacy {
  statisticsIsHidden: boolean;
  socialsIsHidden: boolean;
}
